import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '@/pages/home/components/Logo';
import CtaLink from '@/pages/home/components/CtaLink';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Results', to: '/results' },
  { label: 'Work With Josh', to: '/#work-with-josh' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/about') return location.pathname === '/about';
    if (to === '/results') return location.pathname === '/results';
    return false;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/80 backdrop-blur-md  border-white/5'
          : 'bg-transparent'
      }`}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Logo />

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className={`text-sm font-label font-medium transition-colors whitespace-nowrap ${
                  isActive(l.to)
                    ? 'text-primary-400'
                    : 'text-foreground-600 hover:text-primary-400'
                }`}>
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:block">
            <CtaLink>Apply to Work With Me</CtaLink>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
            aria-label="Toggle menu">
            <i
              className={
                open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'
              }></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-100/95 backdrop-blur-md border-t border-white/5 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-label font-medium text-foreground-700 hover:text-primary-400 transition-colors">
                {l.label}
              </Link>
            ))}
            <div className="mt-2">
              <CtaLink className="w-full">Apply to Work With Me</CtaLink>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
